import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "constants/queryKeys";
import { errorModal } from "modules/error/ErrorHandlingModals";
import { getUserInfoService } from "modules/users";
import { ErrorResponse } from "types";

export const useGetUserInfo = (userId: string, queryEnabled: boolean) => {
  const jwtToken = localStorage.getItem("jwt_Token") ?? null;
  const query = useQuery({
    queryKey: [QUERY_KEYS.user_details, userId],
    queryFn: () => getUserInfoService(userId),
    enabled: userId !== "" && queryEnabled && jwtToken !== "",
    onError: (error: ErrorResponse) => errorModal(error),
    staleTime: Infinity,
    useErrorBoundary: true
  });
  return query;
};
